
import Harmony from "../../../assets/filled/Harmony.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HarmonyIcon({ className, dataTestid = "HarmonyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Harmony data-testid={dataTestid} className={classes} {...rest} />
  );
}
